import { SlackSenderLayout } from "../SlackSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SlackSenderRouterProps } from "../SlackSenderRouterProps";
import { SlackSenderEntities } from "../SlackSenderEntities";
import { NamirasoftMap } from "namirasoft-site-map";

export interface SentListPageProps extends NSARouterMakerResult, SlackSenderRouterProps
{ }

function SentListPage(props: SentListPageProps)
{
	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<SlackSenderLayout {...props}
			action={{
				title: "Report",
				description: "View detailed reports of the messages sent, including channel, message, date, and time.",
				menus: {}
			}}
			pages={{
				entity: SlackSenderEntities.sent(props),
				list: {
					ui: {
						search_box: {
							exclude: {
								load_value: (table, column) =>
								{
									if (namirasoft.slack_sender.tables.sent.name === table)
									{
										let columns = [
											namirasoft.slack_sender.tables.sent.columns.message.name,
											namirasoft.slack_sender.tables.sent.columns.result.name,
										]
										return columns.includes(column);
									}
									return false;
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</SlackSenderLayout>
	);
}

export default SentListPage;